import { UserDetailsDto } from './../../../../data/models/dto/user-details.dto';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-children-details',
  templateUrl: './children-details.component.html',
  styleUrls: ['./children-details.component.scss']
})
export class ChildrenDetailsComponent {

  @Input() user?: UserDetailsDto

}
